export default {
  getCategories(lang = 'en') {
    if (lang === 'en') {
      return [
        'Food / F&B / Restaurants',
        'Humour / Role playing / skits',
        'Couple',
        'Health & Fitness / Sports',
        'Beauty & Personal Care',
        'Tech',
        'Home',
        'Music/Dance/Sing',
        'Travel / Places to visit',
        'Gaming',
        'Fashion',
        'Finance',
        'Family & Parenting',
        'Entrepreneurship / business owner',
        'Education / Lifehacks',
        'Shopping & Ecommerce',
        'Luxury'
      ]
    } else if (lang === 'th') {
      return [
        'อาหาร/อาหารและเครื่องดื่ม/ร้านอาหาร',
        'การเล่นบทบาท',
        'คู่รัก',
        'สุขภาพและฟิตเนส/ กีฬา',
        'ความงามและการดูแลส่วนบุคคล',
        'เทคโนโลยีและไลฟ์สไตล์',
        'บ้าน',
        'ดนตรี',
        'การเดินทาง/สถานที่ท่องเที่ยว',
        'การเล่นเกม',
        'แฟชั่น',
        'การเงิน',
        'การเลี้ยงดู',
        'ผู้ประกอบการ/เจ้าของธุรกิจ',
        'เคล็ดลับชีวิต/การศึกษา',
        'ช้อปปิ้งและอีคอมเมิร์ซ',
        'สินค้าฟุ่มเฟือย/ไลฟ์สไตล์'
      ]
    } else if (lang === 'vn') {
      return [
        'Thực phẩm/F&B/Nhà hàng',
        'Hài hước/Nhập vai/Tiểu phẩm',
        'Cặp đôi',
        'Sức khỏe & Thể hình/Thể thao',
        'Chăm sóc sắc đẹp & cá nhân',
        'Công nghệ & Phong cách sống',
        'Gia đình',
        'Âm nhạc',
        'Du lịch/ Địa điểm thăm quan',
        'Gaming',
        'Thời trang',
        'Tài chính',
        'Làm bố mẹ',
        'Kinh doanh/ chủ doanh nghiệp',
        'Lifehacks/ Giáo dục',
        'Mua sắm và E- Commerce',
        'Hàng hoá xa xỉ/ Lifestyle'
      ]
    } else if (lang === 'id') {
      return [
        'Makanan/F&B/Restoran',
        'Humor/Role Playing/Sandiwara',
        'Pasangan',
        'Kesehatan & Kebugaran/Olahraga',
        'Kecantikan & Perawatan Pribadi',
        'Teknologi & Gaya Hidup',
        'Rumah',
        'Musik',
        'Travel/Tempat untuk Dikunjungi',
        'Gaming',
        'Fashion',
        'Keuangan',
        'Parenting',
        'Kewirausahaan/pemilik usaha',
        'Lifehack/Pendidikan',
        'Shopping & Ecommerce',
        'Barang Mewah/Gaya Hidup'
      ]
    } else if (lang === 'cn') {
      return [
        '食品/餐饮/餐厅',
        '幽默/角色扮演/小品',
        '情侣',
        '健康与健身/体育',
        '美容与个人护理',
        '科技与生活方式',
        '家居',
        '音乐',
        '旅行/旅游景点',
        '电子游戏',
        '时尚',
        '金融',
        '家长类',
        '创业/企业家',
        '生活技巧/教育',
        '购物与电子商务',
        '奢侈品/生活方式'
      ]
    } else if (lang === 'jp') {
      return [
        '食品/F&B/レストラン',
        'ユーモア/ロールプレイング/スキット',
        'カップル',
        '健康とフィットネス/スポーツ',
        '美容とパーソナルケア',
        'テクノロジー',
        'ホーム',
        '音楽/ダンス/シング',
        '旅行/訪問地',
        'ゲーミング',
        'ファッション',
        '金融',
        'ファミリー&パレンティング',
        '起業家/事業主',
        '教育/ライフハック',
        'ショッピング&Eコマース',
        'ラグジュアリー'
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Influencer/influencerHelper.js